/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Draft_Save_FailedInputs */

const en_landing_studio_draft_save_failed = /** @type {(inputs: Landing_Studio_Draft_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not save your draft. Keep your original image and prompt before retrying sign-in or checkout.`)
};

const zh_landing_studio_draft_save_failed = /** @type {(inputs: Landing_Studio_Draft_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`草稿保存失败，请先下载原图并保留提示词，再重试登录或支付。`)
};

/**
* | output |
* | --- |
* | "Could not save your draft. Keep your original image and prompt before retrying sign-in or checkout." |
*
* @param {Landing_Studio_Draft_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_draft_save_failed = /** @type {((inputs?: Landing_Studio_Draft_Save_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Draft_Save_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_draft_save_failed(inputs)
	return zh_landing_studio_draft_save_failed(inputs)
});
export { landing_studio_draft_save_failed as "landing.studio.draft_save_failed" }